import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'underscoreless',
    standalone: false
})
export class UnderscorelessPipe implements PipeTransform {
  /**
   *
   * @param {string} value
   * @returns {string}
   */
  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }
}
